import type { RootState } from "@/app/store";

export const selectRace = (state: RootState) => state.race;
export const selectRaceList = (state: RootState) => state.race.raceList;
export const selectNextRaceTime = (state: RootState) =>
  state.race.nextRaceTime;
export const selectRaceXp = (state: RootState) => state.race.raceXp;
export const selectIsRaceBusy = (state: RootState) =>
  state.race.isCreatingRaceLobby ||
  state.race.isJoiningRaceLobby ||
  state.race.isCancellingRaceLobby ||
  state.race.isLoadingRaceList;
